


























import { Question } from '@/resource/question/question.model';
import { Component, Prop, Vue } from 'vue-property-decorator';
import QuestionContainer from '@/components/questions/QuestionContainer.vue';
import QuestionInfo from '../../question/QuestionInfo.vue';
import QuestionBankButton from './QuestionBankButton.vue';
import { FetchQuestionsParams } from '@/resource/question/questions.store';

@Component({
  components: { QuestionContainer, QuestionInfo, QuestionBankButton },
})
export default class QuestionBankItem extends Vue {
  @Prop({ default: [] })
  question: Question;

  @Prop({ required: true })
  isSubjective: boolean;

  @Prop({ required: true })
  questionsFilter: FetchQuestionsParams;

  @Prop({ required: true })
  isQuestionBankItemLoading: boolean;
}
